import { render, staticRenderFns } from "./basemodal.vue?vue&type=template&id=56780bee&"
import script from "./basemodal.vue?vue&type=script&lang=ts&"
export * from "./basemodal.vue?vue&type=script&lang=ts&"
import style0 from "./basemodal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "basemodal.vue"
export default component.exports